import React, { Component } from 'react';
import './App.scss';
import './icons.css';

import createHeader from './components/Header';
import createFooter from './components/Footer';
import Contact from './components/Contact';
import createHome from './components/Home';
import createAbout from './components/About';
import createServices from './components/Services';
import createProducts from './components/Products';
import createMap from './components/Map';

let Header = createHeader(React);
let Footer = createFooter(React);
let Home = createHome(React);
let About = createAbout(React);
let Services = createServices(React);
let Products = createProducts(React);
let Map = createMap(React);

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <Home />
        <About />
        <Services />
        <Products />
        <div className="video">
          <a href="https://www.youtube.com/watch?v=3cIEx9QyIP0" rel="noopener noreferrer" title="Video de Productora de Nuez" target="_blank">
            <i className='icon-play2' />
          </a>
        </div>
        <Contact />
        <Map
          center={{lat: 29.075590, lng: -111.079558}}
          zoom={14}
          language="es"/>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js